module.exports = __webpack_public_path__ + "static/media/Cryptocurrency_predictor.4a5d4b87.png";